import { render } from "./Form.vue?vue&type=template&id=69a1ce4a"
import script from "./Form.vue?vue&type=script&lang=js"
export * from "./Form.vue?vue&type=script&lang=js"

import "./Form.vue?vue&type=style&index=0&id=69a1ce4a&lang=scss"
script.render = render

export default script